import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseHttpService } from '@nimbus-library/features/shared/services/base-http/base-http.service';
import { IWallboardAccessRequest, IWallboardAccessResponse } from '../../models/wallboard-authentication.model';
import { WallboardApiRoutes } from '../../models/api-routes.const';
import { WallboardConst } from '../../models/wallboard.const';

@Injectable({ providedIn: 'root' })
export class WallboardAccessApiClient {
  public constructor(private readonly baseHttpService: BaseHttpService) {}

  public access(token: string): Observable<IWallboardAccessResponse> {
    const request: IWallboardAccessRequest = { token };
    return this.baseHttpService.post(WallboardApiRoutes.Access.access(), request);
  }

  public renew(): Observable<IWallboardAccessResponse> {
    return this.baseHttpService.post(WallboardApiRoutes.Access.renew(), null);
  }

  public end(): Observable<void> {
    return this.baseHttpService.post(WallboardApiRoutes.Access.end(), null, WallboardConst.requestHeaders);
  }
}
